import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/views/MainHomePages/LoginPage.vue";
import NoAccess from "@/views/MainHomePages/NoAccess.vue";
import { getCurrentUser } from "aws-amplify/auth";
const routes = [
  {
    path: "/",
    name: "LoginPage",
    meta: { public: true },
    component: LoginPage,
  },
  {
    path: "/NoAccess",
    name: "NoAccess",
    meta: { public: true },
    component: NoAccess,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",

    component: () =>
      import(
        /* webpackChunkName: "LandingPage" */ "../views/MainHomePages/LandingPage.vue"
      ),

    children: [
      {
        path: "/Dashboard",
        name: "Dashboard",
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "../views/ChildHomePages/Dashboard.vue"
          ),
      },
      {
        path: "/MyAssets",
        name: "MyAssets",
        component: () =>
          import(
            /* webpackChunkName: "MyAssets" */ "../views/ChildHomePages/MyAssets.vue"
          ),
      },


      {
        path: "/:MainRouteName/Asset-Information",
        name: "AssetTabs",
        component: () =>
          import(
            /* webpackChunkName: "AssetTabs" */ "../components/Assets/Cards/AssetTabs.vue"
          ),
        //          meta: {
        //   activeMenu: "/MyAssets"
        // }
      },
      {
        path: "/Manufacturers",
        name: "Manufacturers",
        component: () =>
          import(
            /* webpackChunkName: "Manufacturers" */ "../views/ChildHomePages/Manufacturers.vue"
          ),
      },
      {
        path: "/Suppliers",
        name: "Suppliers",
        component: () =>
          import(
            /* webpackChunkName: "Suppliers" */ "../views/ChildHomePages/Suppliers.vue"
          ),
      },

      {
        path: "/Locations",
        name: "Locations",
        component: () =>
          import(
            /* webpackChunkName: "Locations" */ "../views/ChildHomePages/Locations.vue"
          ),
      },
      {
        path: "/Categories",
        name: "Categories",
        component: () =>
          import(
            /* webpackChunkName: "Categories" */ "../views/ChildHomePages/Categories.vue"
          ),
      },

      {
        path: "/Technicians-By-Categories",
        name: "Technicians-By-Categories",
        component: () =>
          import(
            /* webpackChunkName: "ViewTechniciansByCategory" */ "@/components/Technicians/Cards/ViewTechniciansByCategory.vue"
          ),
      },

      {
        path: "/:MainRouteName/Sub-Category",
        name: "Sub-Category",
        component: () =>
          import(
            /* webpackChunkName: "Sub-Category" */ "@/components/SubCategories/Cards/SubCategory.vue"
          ),
      },

      {
        path: "/Users",
        name: "UserManagement",
        component: () =>
          import(
            /* webpackChunkName: "UserManagement" */ "../views/ChildHomePages/UserManagement.vue"
          ),
      },

      {
        path: "/Admins",
        name: "Admins",
        component: () =>
          import(
            /* webpackChunkName: "Admins" */ "../views/ChildHomePages/Admins.vue"
          ),
      },

      {
        path: "/Roles",
        name: "Roles",
        component: () =>
          import(
            /* webpackChunkName: "Roles" */ "../views/ChildHomePages/Roles.vue"
          ),
      },
      {
        path: "/AuditLogs",
        name: "AuditLogs",
        component: () =>
          import(
            /* webpackChunkName: "AuditLogs" */ "../views/ChildHomePages/AuditLogs.vue"
          ),
      },
      {
        path: "/Filters",
        name: "Filters",
        component: () =>
          import(
            /* webpackChunkName: "Filters" */ "../views/ChildHomePages/Filters.vue"
          ),
      },
      {
        path: "/Verification",
        name: "Verification",
        component: () =>
          import(
            /* webpackChunkName: "Verification" */ "../views/ChildHomePages/Verification.vue"
          ),
      },
      {
        path: "/:MainRouteName/Verification-Reports",
        name: "ViewVerificationReports",
        component: () =>
          import(
            /* webpackChunkName: "Verification" */ "../components/VerificationReports/Cards/ViewVerificationReports.vue"
          ),
      },

      {
        path: "/:MainRouteName/Asset-Verification-Form",
        name: "AssetVerificationReportForm",
        component: () =>
          import(
            /* webpackChunkName: "Asset-Verification-Form" */ "../components/VerificationReports/Cards/AssetVerificationReportForm.vue"
          ),
      },
      {
        path: "/Maintenance",
        name: "Maintenance",
        component: () =>
          import(
            /* webpackChunkName: "Maintenance" */ "../views/ChildHomePages/Maintenance.vue"
          ),
      },


      {
        path: "/:MainRouteName/Maintenance-Report",
        name: "Maintenance-Report",
        component: () =>
          import(
            /* webpackChunkName: "Maintenance-Report" */ "@/components/Assets/Cards/ViewAssetMaintenanceReport.vue"
          ),
      },
      {
        path: "/AllContracts",
        name: "AllContracts",
        component: () =>
          import("../views/ChildHomePages/AllContracts.vue")
      },
      {
        path: "/OtherSettings",
        name: "OtherSettings",
        component: () =>
          import(
            /* webpackChunkName: "OtherSettings" */ "../views/ChildHomePages/OtherSettings.vue"
          ),
      },
      {
        path: "/FieldRepository",
        name: "Field Repository",
        component: () =>
          import(
            /* webpackChunkName: "FieldRepository" */ "../views/ChildHomePages/FieldRepository.vue"
          ),
      },
      {
        path: "/Organization",
        name: "Organization",
        component: () =>
          import(
            /* webpackChunkName: "Organization" */ "../views/ChildHomePages/Organization.vue"
          ),
      },
      {
        path: "/Version",
        name: "Version",
        component: () =>
          import(
            /* webpackChunkName: "Version" */ "../views/ChildHomePages/Version.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// router.afterEach((to, from) => {
//   sessionStorage.setItem("previousRoute", from.path);
// });
router.beforeEach(async (to, from, next) => {
  if (to.meta?.public) {
    return next();
  }

  try {
    await getCurrentUser(); // throws if no authenticated session
    return next();
  } catch (error) {
    // Not authenticated — send to login, remember the full intended URL
    return next({
      path: "/",
      query: { redirect: to.fullPath },
    });
  }
});

export default router;
